import { render, staticRenderFns } from "./insuranceTabInfo.vue?vue&type=template&id=20440c13&scoped=true"
import script from "./insuranceTabInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./insuranceTabInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./insuranceTabInfo.vue?vue&type=style&index=0&id=20440c13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20440c13",
  null
  
)

export default component.exports